module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slide"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": _vm.slide.image.sizes.slide,
      "width": "700",
      "height": "400"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.slide.content)
    }
  }), _vm._v(" "), (_vm.slide.button_link !== 'none') ? _c('p', [(_vm.slide.button_link === 'ext') ? _c('a', {
    staticClass: "btn btn-lg btn-primary",
    attrs: {
      "href": _vm.slide.button_link_external,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.slide.button_link_text))]) : _vm._e(), _vm._v(" "), (_vm.slide.button_link === 'int') ? _c('router-link', {
    staticClass: "btn btn-lg btn-primary",
    attrs: {
      "to": _vm.internalLink
    }
  }, [_vm._v(_vm._s(_vm.slide.button_link_text))]) : _vm._e()], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2f290643!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/Slide.vue
// module id = 312
// module chunks = 1